import React, { ReactElement } from 'react';
import Pill from './pill';

interface BatteryPill {
  value: number;
  isEmitter?: boolean;
}

function BatteryPill({ value, isEmitter = false }: BatteryPill): ReactElement {
  if (isEmitter) {
    return (
      <Pill
        label="n.v."
        className="ml-5 w-24 bg-gray-500 flex items-center justify-center text-white"
      />
    );
  }

  if (value <= 2.4) {
    return (
      <Pill
        label={`${value.toString()} V`}
        className="ml-5 w-24 bg-red-500 flex items-center justify-center text-white"
      />
    );
  }

  if (value >= 2.4 && value <= 2.5) {
    return (
      <Pill
        label={`${value.toString()} V`}
        className="ml-5 w-24 bg-yellow-500 flex items-center justify-center text-white"
      />
    );
  }

  if (value > 2.5) {
    return (
      <Pill
        label={`${value.toString()} V`}
        className="ml-5 w-24 bg-green-500 flex items-center justify-center text-white"
      />
    );
  }

  return (
    <Pill
      label={`${value.toString()} V`}
      className="ml-5 w-24 bg-gray-500 flex items-center justify-center text-white"
    />
  );
}

export default BatteryPill;
